<template>
  <div>
    <div class="tab-box" ref="tabBox" id="tab-box" v-if="carNumberList.length > 0">
      <div class="tabs-content">
        <button
          id="from-favorite"
          class="tabs-item left"
          :class="{ 'is-active': addFromFavorite }"
          :key="favorite-tab"
          @click="handleTab(true)"
        >
          <span>從常用車號申請</span>
        </button>
      </div>
      <div class="tabs-content">
        <button
          id="from-input"
          class="tabs-item right"
          :class="{ 'is-active': !addFromFavorite }"
          :key="input-tab"
          @click="handleTab(false)"
        >
          <span>自行輸入</span>
        </button>
      </div>
    </div>
    <div class="bg-white padding" style="position: relative; z-index: 2" ref="card" v-show="carNumberList.length && addFromFavorite">
      <div class="dark-card">
        <div v-for="(item, i) in carNumberList" :key="i" class="flex border">
          <div>
            <div>{{ item.car_number }}</div>
            <div style="font-size: 14px; color: #c7c7c7">{{ getCarTypeName(item.car_type, item.car_number) }}</div>
          </div>
          <div class="agree-label">
            <input type="checkbox" :id="'car-' + i" v-model="item.checked" />
            <label :for="'car-' + i"></label>
          </div>
        </div>
      </div>
    </div>
    <div class="padding bg-white">
      <div class="form" v-if="!addFromFavorite">
        <div class="item">
          <div class="field"><span class="required">*</span>車種</div>
          <div class="carType">
            <div :class="{'radio-group': true, 'active': carType=='M'}" @click.prevent="carType = 'M'" style="margin-right: 8pt">
              <input type="radio" id="motorcycle" name="carType" v-model="carType" value="M" />
              <label for="motorcycle">機車</label>
            </div>
            <div :class="{'radio-group': true, 'active': carType=='C'}" @click.prevent="carType = 'C'" style="margin-left: 8pt">
              <input type="radio" id="car" name="carType" v-model="carType" value="C" />
              <label for="car">汽車</label>
            </div>
          </div>
        </div>
        
        <div class="item">
          <div class="field">
            <span class="required">*</span>車號
            <span class="text-gray2"  v-if="carType !== 'M1'">（範例：ABC-1234 或 1234-ABC）</span>
            <span class="text-gray2"  v-else>（範例：AB12345）</span>
          </div>
          <div class="carNumber slowVehicle" v-if="carType === 'M1'">
            <input name="carNumber" v-model.trim="number" maxlength="7" @keyup="changeCarNumber" ref="number" autocomplete="off" />        
          </div>
          <div class="carNumber" v-else>
            <input name="carNumber0" v-model.trim="number0" maxlength="4" @keyup="changeValue0" ref="number0" autocomplete="off" />
            <span class="space-line"></span>
            <input name="carNumber1" v-model.trim="number1" maxlength="4" @keyup="changeValue1" ref="number1" autocomplete="off" />
          </div>
        </div>
      </div>
      <button class="btn btn-primary" :disabled="isDisabled" @click="clickNext" v-if="!addFromFavorite">新增</button>
      <button class="btn btn-primary" :disabled="isDisabled" @click="clickNext" v-if="addFromFavorite">申請</button>
      <div class="hint" @click="clickParkgingFeeSupportCityList()"><span>支援區域</span><img src="../../assets/images/infoButton.png" style="width: 24px; height: 24px;"></div>
    </div>
    <div class="padding description">
      <ul class="text-gray2">
        <li>完成申請路邊停車費自動扣繳，日後收到帳單將自動繳納，如有收到待繳通知請忽略訊息；請記得解除在其他平台的自動扣繳設定，避免重複繳費。</li>
        <li>繳納後如欲查詢資訊，請至交易紀錄或各停管處網站確認。</li>
      </ul>     
    </div>
    <div :class="isModifing ? 'mask' : ''" ref="mask"></div>  
  </div>
</template>

<script>
import { queryFavoriteVehicleList, queryParkingFeeBindingList  } from '../../api/api';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'binding-roadside-parking',
  components: {  },
  data() {
    return {
      addFromFavorite: false,
      carNumberList: [],
      bindingVehicleList: [],
      isModifing: false,
      carType: 'M',
      carNumber0: '',
      carNumber1: '',
    };
  },
  created() {   
  },
  mounted() {
    var height = this.$refs.card.clientHeight;
    this.$refs.mask.style.top = height + 'px';    
    //this.getFavoriteCarNumber();     
    this.getBindingVehicleList();
  },
  activated() {    
    this.$store.dispatch('sentApp', {
      action: 'configureAppWebPage',
      payload: { title: '申請自動扣繳', headerType: 'white' },
    });
  },
  computed: {
    ...mapGetters(['supportFeatures']),
    isDisabled() {
      if (this.addFromFavorite) {
        return this.carNumberList.filter((item) => item.checked).length === 0;
      } else {
        if (this.carType === 'M1') {
          return this.carNumber.length !== 7;
        } else {
          return this.carNumber.split('-')[0] === '' || this.carNumber.split('-')[1] === '';
        }
      }
    },
    carNumber: {
      get: function() {
        return this.carNumber0 + '-' + this.carNumber1;
      }
    },
    number: {
      get: function () {
        return this.carNumber;
      },
      set: function (val) {
        var number = val.toUpperCase().replace(/\s/g, '');
        if (number.length > 7) {
          number = number.substring(0, 7);
        }
        this.carNumber = number;
      },
    },
    number0: {
      get: function () {
        return this.carNumber0;
      },
      set: function (val) {
        var number = val.toUpperCase().replace(/\s/g, '');
        if (number.length > 4) {
          number = number.substring(0, 4);
        }
        this.carNumber0 = number;
      },
    },
    number1: {
      get: function () {
        return this.carNumber1;
      },
      set: function (val) {
        var number = val.toUpperCase().replace(/\s/g, '');
        if (number.length > 4) {
          number = number.substring(0, 4);
        }
        this.carNumber1 = number;
      },
    },
  },

  methods: {
    ...mapActions(['sentApp',]),
    clickParkgingFeeSupportCityList() {
      this.$router.push({
        path: '/parkingFee/supportBindingCity',
        query: {},
      });
    },
    changeCarNumber(e) {
      e.target.value = e.target.value.replace(/[\W]/g, '');
      if (this.number.length >= 7) {
        this.$refs.number.blur();
      }
    },
    changeValue0(e) {
      e.target.value = this.trimLength(e.target.value.replace(/[\W]/g, ''), 4);
      if (this.number0.length >= 4) {
        this.$refs.number1.focus();
      }
    },
    changeValue1(e) {
      e.target.value = this.trimLength(e.target.value.replace(/[\W]/g, ''), 4);
      if (this.number1.length >= 4) {
        this.$refs.number1.blur();
      }
    },
    trimLength(string, length) {
      return string.length > length ? 
             string.substring(0, length) :
             string;
    },  
    localCarTypeToCarType(carType) {
      switch (carType) {
        case 'M1':
          return 'M';
        default:
          return carType;
      }
    },
    getCarTypeName(carType, carNumber) {
      switch(carType) {
        default:
        case 'C':
          return '汽車';
        case 'M':
        const regexp = RegExp(/^[A-Z]{2}[0-9]{5}$/);      
        let result = regexp.test(carNumber);
        if (result) {
            return '微電車';
          }
          return '機車';
        case 'B':
          return '拖車';
        case 'H':
          return '重機';
        case 'M1':
          return '微電車';
      }
    },
    
    getFavoriteCarNumber() {
      queryFavoriteVehicleList().then((res) => {
        if (res.error === undefined) {
          this.carNumberList = res.vehicle_list;
          if (this.carNumberList.length > 0) {
            this.addFromFavorite = true;
          }
          setTimeout(() => {
            var height = this.$refs.card.clientHeight;
            this.$refs.mask.style.top = height + 'px';
          }, 1000);
        }
      });
    },
    getBindingVehicleList() {
      queryParkingFeeBindingList().then((res) => {
        if (res.error === undefined) {
          this.bindingVehicleList = res.vehicle_list;          
        }
      });
    },
    handleTab(isFavorite) {
      this.addFromFavorite = isFavorite;
    },
    clickNext() {    
      let carList = [];
      var duplicateCheck = false;
      if (this.addFromFavorite) {
        carList = this.carNumberList.filter((item) => item.checked);
        carList.forEach((item) => {
          item.car_type_description = this.getCarTypeName(item.car_type, item.car_number);
        });
      } else {
        if (this.carNumber.length>8) {
          alert('請輸入正確的車牌號碼');
          return false;
        }
        this.bindingVehicleList.forEach((item) => {
          if (item.car_number === this.carNumber && item.car_type === this.carType) {
            alert('綁定失敗！\n此車牌已綁定於悠遊付路邊停車自動扣繳，您可電洽本公司客服確認，電話：412-8880（手機及金馬地區請加02）');
            duplicateCheck = true;
            return;
          }
        });
        carList.push({
          car_type: this.carType,
          car_type_description: this.getCarTypeName(this.carType, this.carNumber),
          car_number: this.carNumber,
        });
      }
      if (!duplicateCheck) {
        this.sentApp({
            action: 'parkingFeePaymentAuthorize',
            payload: { data: carList },
          });
      }
      
    },
    getFormData(fieldName, data) {
      this.form[fieldName] = data;
    },
  },
};
</script>

<style scoped>
.hint {
  display: flex;
  flex-flow: row;
  align-items: center;
  margin: 18px auto 0px auto;
  justify-content: center;
}

.hint span {
  color: rgba(64, 64, 64, 0.6);
  font-size: 14px;
  text-align: center;  
  line-height: 24px;
}


.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dark-card {
  margin: 0;
}

.dark-card .flex {
  padding: 9pt 0;
  border-bottom: 1px solid rgba(64, 64, 64, 0.75);
}

.form {
  margin-bottom: 16px;
  margin-top: 0;
}

.form .item:not(:first-child) {
  margin-top: 24pt;
}

.agree-label label::before {
  content: "";
  background: url("../../assets/images/switch_button.png") no-repeat center;  
  background-size: 44px;
  width: 44px;
  height: 44px;
  -webkit-box-sizing: border-box;
  -webkit-transition: background ease-in .1s
}

.carNumber {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.carNumber input {
  background: rgba(64, 64, 64, 0.05);
  border: none;
  font-size: 16px;
  line-height: 30px;
  padding: 11pt 0;
  width: 50%;
  text-align: center;
}

.carNumber.slowVehicle input {
  width: 100%;
}

.carType {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.carType .radio-group {
  padding: 11pt 0;
  border: 1px solid rgba(64, 64, 64, 0.1);
  border-radius: 4pt;
  display: flex;
  justify-content: center;
  width: 50%;
  align-items: center;
  -webkit-box-sizing: border-box;
  -webkit-transition: background ease-in 0.1s;
}

.carType .radio-group.active {
  background: #f9b238;
  color: #fff;
  font-size: 16px;
}

.carType .radio-group input[type='radio'] {
  display: none;
}

.space-line {
  margin: 0 8pt;
  background: #000;
  height: 1px;
  content: '';
  display: block;
  width: 20pt;
}


.tab-box {
  margin-top: 16px;
  display: flex;
  border-bottom-color: #40404019;
  border-width: 1px;  
  border-bottom-style: solid;
}

.tabs-content {
  flex-basis: 50%;
  align-items: center;
  display: flex;
}

.tabs-content button {
  all: unset;
  cursor: pointer;
  padding: 8px;
  text-align: center;
  color: #404040c0;
  flex-grow: 1;  
}

.tabs-content button.right {
  margin-right: 16px;
}

.tabs-content button.left {
  margin-left: 16px;
}

.tabs-content button.is-active {
  border-bottom-color: rgb(0, 122, 200);
  border-width: 2px;  
  border-bottom-style: solid;
}

.tabs-content button.is-active span {
  color: rgb(0, 122, 200);
}

.tabs-content button span {
  font-size: 16px;
}

</style>
